module.exports = __webpack_public_path__ + "static/media/image_42.4d0d62d2.png";